// Exports the "imagetools" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/imagetools')
//   ES2015:
//     import 'tinymce/plugins/imagetools'
require('./plugin.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/tinymce/plugins/imagetools/index.js
 ** module id = 539
 ** module chunks = 1
 **/